import { API_BASE } from "./config.js";

async function get(path) {
  const url = `${API_BASE.replace(/\/$/, "")}${path}`;
  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${text.slice(0, 120)}`);
  }
  return res.json();
}

export function fetchFeed({ langs, sectors }) {
  const params = new URLSearchParams();
  if (langs?.length) params.set("langs", langs.join(","));
  if (sectors?.length) params.set("sectors", sectors.join(","));
  return get(`/api/feed?${params}`);
}

export function fetchDefinition(word, lang) {
  const params = new URLSearchParams({ word, lang });
  return get(`/api/define?${params}`);
}